module.exports = __webpack_public_path__ + "img/mapoure-1024x576-1-thegem-portfolio-masonry-14.80c41b88.png";